/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/24/triangle-down': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21 5H3a1.001 1.001 0 00-.8 1.6l9 12a.998.998 0 001.6 0l9-12A.999.999 0 0021 5z" _fill="#3f3f3f"/>'
  }
})
